import { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import FormSelect from '../Form/FormSelect';
import FormTextField from '../Form/FormTextField';
import SelectQuery from '../Select/SelectQuery';
import JobRecordTableau from './JobRecordTableau';
import Pod from '../Shared/Pod';
import Tooltip from '@mui/material/Tooltip';
import Button from '../Buttons/Button';
import Modal from '../Shared/Modal';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const JobRecordRowAttribute = props => {
    const attr = props.attr
    const item = props.item
    const value = attr.type === "sqleditor" ? item.queryId : item[attr.name] || ''

    const [modal, setModal] = useState();
    return (
        // <Tooltip title={attr.label}>
        <Grid>
            <Pod
                icon={attr.icon}
                label={attr.label}
                count={attr.count && value.length}
                color="primary"
                launch={attr.launch && value && (() => window.open(attr.launch + value, '_blank', 'noopener,noreferrer'))}
                loading={props.loading}
                fullWidth
            >
                <Modal data={modal} close={() => setModal()} />
                {
                    attr.type === 'select' &&
                    <FormSelect
                        name={attr.name}
                        value={value}
                        options={props?.options || attr.options}
                        handler={props.handler}
                        disabled={props.disabled || attr.disabled}
                        disableUnderline
                    />
                }
                {
                    attr.type === 'input' &&
                    <FormTextField
                        name={attr.name}
                        value={item[attr.name] || ''}
                        disabled={attr.disabled}
                        disableUnderline
                        handler={props.handler}
                    />
                }
                {
                    attr.type === 'sqleditor' &&
                    <SelectQuery
                        name="queryId"
                        value={value}
                        handler={props.handler}
                        disableUnderline
                    />
                }
                {
                    attr.type === 'tableau' &&
                    <Grid container>
                        <Grid >
                            <Button
                                type="launch"
                                label="Configure"
                                handler={() => setModal(
                                    <JobRecordTableau
                                        rowNumber={props.rowNumber}
                                        item={item}
                                        handler={e => {
                                            props.handler(e)
                                            setModal()
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs sx={{ justifyContent: 'right' }}>
                            {item.tableauUrl && item.tableauParameter && <CheckCircleIcon color="success" /> }
                        </Grid>
                    </Grid>
                }

            </Pod>
        </Grid>
        // </Tooltip>
    )
}
export default JobRecordRowAttribute;